import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import ImgCustomerSupport from '../../../../public/images/illustrations/illustration-customer-support-m-dark.png'
import { type OpenableControls } from '../../../generic-hooks'
import { StaticImage } from '../../../image'
import { directContactTelephoneDialogIsCustomerSupportAvailable } from '../../directContactTelephoneDialogIsCustomerSupportAvailable'
import { DirectContactTelephoneUnavailable } from '../DirectContactTelephoneUnavailable'

import { DirectContactTelephoneDialogAvailable } from './DirectContactTelephoneDialogAvailable'

export const DirectContactTelephoneDialog: FC<{
  modalControls: OpenableControls
}> = ({ modalControls }) => {
  return (
    <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
      <DialogTitle onClose={modalControls.handleClose}>
        <FormattedMessage id="contact.callUsModal.title" />
      </DialogTitle>
      <DialogContent className="flex h-full flex-col items-center gap-2 p-4">
        <div className="flex w-80 flex-col items-center gap-4 text-start tablet:mx-36 tablet:text-center">
          <StaticImage
            alt="Customer Support Illustration"
            className="h-36 w-40"
            src={ImgCustomerSupport}
          />
          <h3 className="w-full text-xl font-medium">
            <FormattedMessage id="contact.directContactSection.customerSupportDialog.title" />
          </h3>
          {directContactTelephoneDialogIsCustomerSupportAvailable() ? (
            <DirectContactTelephoneDialogAvailable />
          ) : (
            <DirectContactTelephoneUnavailable isPharmaModal={false} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
